module.exports = __webpack_public_path__ + "static/media/books-lover.a8a0b320.svg";